import { useEscalationReviewState } from "@/lib/states/escalation-review-state"
import { queueEscalationReviewSeed } from "@/screens/app/inbox/helpers/escalation-review-autostart"
import { useThreadSidebarState } from "@/screens/app/sidebar"
import { useSidebarAiChatState } from "@/screens/app/threads/components/right-bar/ai-chat/sidebar-ai-chat-state"

// Must match AI_CHAT_ACTOR_NAME in packages/api update-ai-thread.ts (server-only).
export const AI_CHAT_ACTOR_NAME = "Productlane Agent"

// AUTO_REPLY is the canned acknowledgement or out-of-office notice alone.
export const isAgentEmailReply = (email: {
	type: string
	source: string | null
}) => email.type === "OUTBOUND" && email.source === "AI"

// Close-loop and bug follow-ups are AI rows too, but no agent session wrote them.
export const isAgentLiveChatReply = (message: {
	role: string
	aiChatSessionId?: string | null
}) => message.role === "AI" && !!message.aiChatSessionId

export function startReplyImprovement(threadId: string): () => void {
	useEscalationReviewState.getState().markAutoReviewed(threadId)
	const sidebar = useThreadSidebarState.getState()
	sidebar.setActiveTab("ai-chat")
	sidebar.open()
	return queueEscalationReviewSeed({
		threadId,
		store: useSidebarAiChatState,
		force: true,
	})
}
